module.exports = __webpack_public_path__ + "img/zhuanpan-bg2.7e3cad64.png";